import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseService } from './base/base.service';

import { ListResponse, ObjectResponse } from '../interfaces';

import {
  AllEvaluationMethodsResponse
} from '../models';

import { AppConfig } from './app-config';

@Injectable()
export class AllEvaluationMethodService extends BaseService<AllEvaluationMethodsResponse> {

  constructor(protected http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  public getAllEvaluationMethods(transId: number): Observable<ListResponse<AllEvaluationMethodsResponse>> {
    return this.http
      .get<ListResponse<AllEvaluationMethodsResponse>>(`${this.getResourceUrl()}${transId}/methods/all-methods`);
  }

  public saveNotAppliedEvaluationMethodDiscussion(transId: number,
    methodEvaluation: AllEvaluationMethodsResponse):
    Observable<ObjectResponse<AllEvaluationMethodsResponse>> {
    const nameId = methodEvaluation.notAppliedEvaluationMethodId ? methodEvaluation.notAppliedEvaluationMethodId : 0;
    const url = `${this.getResourceUrl()}${transId}/methods/not-applied/${nameId}`;

    return this.http.put<ObjectResponse<AllEvaluationMethodsResponse>>(url, methodEvaluation);
  }

  protected getResourceUrl(): string {
    return `${this.baseUrl}transactions/`;
  }
}
